<ui-offcanvas
	[header]="'notifications.title' | translate"
	[open]="offcanvasOpen()"
	[closeOnOutsideClick]="true"
	(closed)="closeOffcanvas()"
>
	@let notificationsLength = notifications()?.length || 0;
	@if (notifications() && !initialLoading()) {
		<div
			class="flex flex-col h-screen max-h-full overflow-hidden"
			data-cy="user-notifications-offcanvas"
		>
			@if (isSummaryButtonVisible()) {
				<ui-button
					type="blue"
					[text]="'summary.start' | translate: { year: year }"
					[fullWidth]="true"
					(buttonClicked)="openSummary()"
					class="hidden lg:block mb-4"
					directivePlausible
					eventName="click: open-summary"
					eventLabel="summary-of-the-year-open-from-notifications"
				></ui-button>
			}
			<ng-content></ng-content>
			<div
				class="flex flex-col max-h-full overflow-hidden"
				[class]="notificationsLength ? 'h-full' : 'h-screen justify-center'"
			>
				<div class="grow overflow-auto pb-3" #articles [hidden]="!notificationsLength">
					@for (notification of notifications(); track notification.id; let idx = $index) {
						<user-notification-item
							[notification]="notification"
							[isExpanded]="!notification.read"
						></user-notification-item>
						@if (idx < notificationsLength - 1) {
							<ui-divider class="c-user-notifications__divider block py-3"></ui-divider>
						}
					}
				</div>

				@if (notificationsLength === 0) {
					<div class="flex flex-col justify-center">
						<img
							src="assets/images/illu_notifications_empty.svg"
							alt="No notifications"
							class="mx-auto my-8"
						/>

						<ui-headline type="h4" class="text-center">
							{{ 'notifications.no_notifications' | translate }}
						</ui-headline>
					</div>
				}
			</div>
		</div>
	} @else {
		<ui-spinner></ui-spinner>
	}
	<ui-button
		offcanvas-button
		[hidden]="initialLoading()"
		[text]="'general.close' | translate"
		[fullWidth]="true"
		(buttonClicked)="closeOffcanvas()"
	></ui-button>
</ui-offcanvas>
